<template>
  <div>
    
    <!-- <div style="min-height:500px;"></div> -->
    <ExplainCell style="height:760px;"></ExplainCell>
  </div>
</template>

<script>
import ExplainCell from "@/components/AboutExamination/ExplainCell";
export default {
  components: {
    ExplainCell
  }
};
</script>
<style lang="less" scoped>
.cell-container {
}
</style>
